export default {
    data() {
        return {
            openedModal: null,
        };
    },

    methods: {
        openModal(id) {
            if(id === null || id === undefined) {
                console.log('Modal: ID is not defined');
                return;
            }

            this.openedModal = id;
        },

        closeModal() {
            this.openedModal = null;
            // console.log('CLOSE modal mixin')
            this.$emit('close')
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/ModalMixin.js